import PerfectScrollbar from "react-perfect-scrollbar";
import Noprofile from "../../../images/profileImage.png";
import {useNotifications} from "../../../hooks/useNotification";
import Loader from "../../components/shared/Loader";
import {useNavigate} from "react-router-dom";
import ImageComponent from "../../components/shared/ImageComponent";
import {proposalDate} from "../../../utils/date";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import QueryErrorState from "../../components/shared/QueryErrorState";

import {getNotificationInterventionIdentifier} from "../../../utils/interventionUrl";
import helpClicLogo from "../../../images/mini-logo.png";
import EmptyState from "../../components/shared/EmptyState";
const NotificationPage = () => {
  const {data, isError, isLoading, error, refetch} = useNotifications({
    page: 0,
    size: 99,
  });
  const navigate = useNavigate();
  if (isLoading) {
    return <Loader className="relative" />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }

  const navigateToChat = (notification) => {
    if (notification?.notifiableType === "offer") {
      navigate(`/annonce/${notification?.notifiableId}`);
    } else if (notification?.notifiableType === "intervention") {
      navigate(`/intervention/${getNotificationInterventionIdentifier(notification)}`, {
        replace: false,
      });
    } else if (["ticket", "ticketMessage"].includes(notification?.notifiableType)) {
      navigate(`/reclamation/${notification?.ticketId || notification?.notifiableId}`, {replace: false});
    } else if (notification?.chatroomId) {
      navigate(`/messages#${notification.chatroomId}`, {replace: false});
    } else if (
      !notification?.chatroomId &&
      notification?.notifiableType === "proposition"
    ) {
      navigate(`/intervention/${getNotificationInterventionIdentifier(notification)}`, {
        replace: false,
      });
    }
    return;
  };

  return (
    <>
      <div className="card !w-full ">
        <div className="card-header  border-0 pb-0">
          <div className="card-title !text-[#19295C] !font-bold !text-base w-full text-left sm:!text-lg 2xl:!text-xl">
            Notifications
          </div>
        </div>

        <div className="card-body !min-h-[70vh]">
          {!data?.length ? (
            <EmptyState className="h-full flex-1 w-full" />
          ) : (
            <PerfectScrollbar
              options={{suppressScrollX: true}}
              style={{height: "90vh", overflowX: "hidden"}}
              id="DZ_W_Todo1"
              className="widget-media dz-scroll ps ps--active-y h-fit max-h-[90vh] "
            >
              <ul className="timeline">
                {data?.map((notif) => (
                  <li
                    className="cursor-pointer"
                    onClick={() => navigateToChat(notif)}
                  >
                    <div className="timeline-panel">
                      <div className="media mr-2 !rounded-full">
                        <ImageComponent
                          alt={"avatar"}
                          className={
                            "!rounded-full !object-cover aspect-square"
                          }
                          src={
                            ["ADMIN", "SUPPORT"].includes(notif?.sender?.selectedRole)
                              ? helpClicLogo
                              : buildImageUrl(notif?.sender?.imageUri)
                          }
                          fallback={
                            <img
                              alt=""
                              className="!rounded-full"
                              src={Noprofile}
                            />
                          }
                        />
                      </div>
                      <div className="media-body">
                        <h5 className="mb-1 text-sm ">{notif?.message}</h5>
                        <small className="d-block">
                          {proposalDate(notif?.createdAt)}
                        </small>
                      </div>
                      {/* <Dropdown>
                        <Dropdown.Toggle variant="" className="i-false sharp">
                          <div className="w-8 aspect-square rounded-full justify-center items-center flex bg-[#F1F2F7]">
                            <i className=" rotate-90 fi fi-rr-menu-dots-vertical flex items-center"></i>{" "}
                          </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu">
                          <Dropdown.Item
                            className="dropdown-item"
                            to="/widget-basic"
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="dropdown-item"
                            to="/widget-basic"
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> */}
                    </div>
                  </li>
                ))}
              </ul>
            </PerfectScrollbar>
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationPage;
